<template>
    <b-modal
      ref="voucher-confirmation-ref"
      hide-footer
      hide-header
    >
      <div class="vtd-modal-content">
        <div class="vtd-modal-header" style="border-bottom: 1px solid #dee2e6; justify-content: flex-end; padding: 1px;">
          <button
            @click="closeModal"
            type="button"
            class="close"
            aria-label="Close"
          >
            <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
          </button>
        </div>
        <div class="d-block">
            <p class="my-4" style="font-size: larger;">Thank you. We will check the amount against the value of your Card or Voucher and send you confirmation shortly.</p>
        </div>
      </div>
    </b-modal>
  </template>
  <script>
  import dayjs from '@/lib/dayjs';
  
  export default {
   
    methods: {
       showModal() {
        this.$refs["voucher-confirmation-ref"].show();
      },
      closeModal() {
        this.$refs["voucher-confirmation-ref"].hide();
      }
    },
    computed: {
      returnDate() {
        return dayjs().format("DD-MMM-YYYY HH:mm");
      },
    },
  
  };
  </script>
  <style lang="scss">
  </style>
  
  